/* I conti della dashboard dell'agente Indaga, lato schermo. Funzioni pure, provate a parte.

   Il numero che il titolare guarda non è «quante indagini»: è la CATENA — quanti degli
   indirizzi completati dall'agente sono poi diventati un lead esportato. Tutto il resto
   serve a capire perché quel numero è sceso. */

/** Percentuale di `parte` su `tutto`, a un decimale. 0 quando non ha senso. */
export function pct(parte, tutto) {
  const t = Number(tutto) || 0;
  if (t <= 0) return 0;
  return Math.round((Number(parte) || 0) / t * 1000) / 10;
}

/** Numero con i punti delle migliaia. */
export const num = (n) => (Number(n) || 0).toLocaleString('it-IT');

/* Lo stato dell'agente in una parola, con il suo colore. L'attesa NON è spento: è il modo
   in cui l'agente resta pronto a ripartire quando arriva lavoro, e confonderli farebbe
   riaccendere a mano una cosa che è già accesa. */
export function statoAgente(stato) {
  const s = stato || {};
  if (!s.abilitata) return { testo: 'Disattivato', colore: '#64748b', spia: 'off' };
  if (!s.agente_attivo) return { testo: 'Spento', colore: '#ef4444', spia: 'off' };
  if (s.job && s.job.standby) return { testo: 'In standby', colore: '#f59e0b', spia: 'attesa' };
  if (s.in_attesa) {
    const perche = s.motivo_attesa === 'tetto giornaliero' ? 'tetto raggiunto' : 'niente da fare';
    return { testo: `In attesa · ${perche}`, colore: '#f59e0b', spia: 'attesa' };
  }
  return { testo: 'Al lavoro', colore: '#22c55e', spia: 'on' };
}

/** Una durata in secondi detta in italiano: 14.7 -> «15 s», 95 -> «1 min 35 s». */
export function durata(secondi) {
  if (secondi == null) return '—';
  const s = Math.round(Number(secondi) || 0);
  if (s < 60) return `${s} s`;
  const m = Math.floor(s / 60);
  const r = s % 60;
  return r ? `${m} min ${r} s` : `${m} min`;
}

/* Le etichette degli esiti. «Non confermato» è il calderone più grande (sei indagini su
   dieci): l'azienda è stata trovata, ma non si è potuto provare che fosse lei. */
export const ESITI = [
  { k: 'completato', l: 'Completato', c: '#22c55e', d: 'Indirizzo scritto in archivio' },
  { k: 'non_confermato', l: 'Non confermato', c: '#f59e0b', d: 'Trovata, ma senza prova che sia lei' },
  { k: 'non_trovato', l: 'Non trovato', c: '#94a3b8', d: 'Nessuna scheda su Maps' },
  { k: 'incompleto', l: 'Incompleto', c: '#64748b', d: 'Trovato un indirizzo senza civico' },
  { k: 'errore', l: 'Errore', c: '#ef4444', d: 'Tempo scaduto o blocco' },
];

/** Le fette dell'imbuto, pronte da disegnare: etichetta, quanti, percentuale, colore. */
export function fette(imbuto) {
  const i = imbuto || {};
  return ESITI.map((e) => ({ ...e, n: i[e.k] || 0, pct: pct(i[e.k], i.lavorati) }))
    .filter((e) => e.n > 0);
}

/** I tre anelli della catena del valore, col calo a ogni passaggio. */
export function catena(c) {
  const k = c || {};
  return [
    { k: 'completati', l: 'Indirizzi completati', n: k.completati || 0, pct: 100 },
    { k: 'con_copertura', l: 'Con copertura verificata', n: k.con_copertura || 0,
      pct: pct(k.con_copertura, k.completati) },
    { k: 'esportati', l: 'Esportati come lead', n: k.esportati || 0,
      pct: pct(k.esportati, k.completati) },
  ];
}

/** Il colore di un allarme. */
export const coloreAllarme = (livello) => (livello === 'grave' ? '#ef4444' : '#f59e0b');
